"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientAccountToJSON = exports.ClientAccountFromJSONTyped = exports.ClientAccountFromJSON = exports.instanceOfClientAccount = void 0;
var runtime_1 = require("../runtime");
var ClientAccountAccessGroup_1 = require("./ClientAccountAccessGroup");
/**
 * Check if a given object implements the ClientAccount interface.
 */
function instanceOfClientAccount(value) {
    var isInstance = true;
    isInstance = isInstance && "clientId" in value;
    isInstance = isInstance && "clientName" in value;
    isInstance = isInstance && "contactEmailAddress" in value;
    return isInstance;
}
exports.instanceOfClientAccount = instanceOfClientAccount;
function ClientAccountFromJSON(json) {
    return ClientAccountFromJSONTyped(json, false);
}
exports.ClientAccountFromJSON = ClientAccountFromJSON;
function ClientAccountFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'clientId': json['client_id'],
        'clientName': json['client_name'],
        'contactEmailAddress': json['contact_email_address'],
        'accessGroups': !(0, runtime_1.exists)(json, 'access_groups') ? undefined : (json['access_groups'].map(ClientAccountAccessGroup_1.ClientAccountAccessGroupFromJSON)),
    };
}
exports.ClientAccountFromJSONTyped = ClientAccountFromJSONTyped;
function ClientAccountToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'client_id': value.clientId,
        'client_name': value.clientName,
        'contact_email_address': value.contactEmailAddress,
        'access_groups': value.accessGroups === undefined ? undefined : (value.accessGroups.map(ClientAccountAccessGroup_1.ClientAccountAccessGroupToJSON)),
    };
}
exports.ClientAccountToJSON = ClientAccountToJSON;
